
import { defineComponent, ref, reactive, toRefs, onMounted, computed, nextTick, watch } from 'vue'
import { InfoCircleOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import f10Api from '@/api/f10Api'
import globalsets from '@/utils/globalsets'
import * as echarts from 'echarts'
import Charts from '@/components/page/charts.vue'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
const color = globalsets.getColor()
const mydata2: any = {
  total: null,
  data: [
    { value: null, name: '流动负债' },
    { value: null, name: '非流动负债' }
  ]
}
const mydata1: any = {
  ldzcTotal: null,
  ldzc: [
    { value: null, name: '货币资金' },
    { value: null, name: '应收账款' },
    { value: null, name: '存货' },
    { value: null, name: '预付账款' }
  ],
  fldzcTotal: null,
  fldzc: [
    { value: null, name: '固定资产' },
    { value: null, name: '无形资产' },
    { value: null, name: '长期待摊费用' },
    { value: null, name: '商誉' },
    { value: null, name: '其他' }
  ],
  total: null
}
const myColumns: any = {
  ybqy: [
    {
      title: '利润表',
      dataIndex: 'time',
      key: 'time',
      indentStep: 0,
      width: '100px'
    },
    {
      title: '指标',
      dataIndex: 'Title',
      key: 'Title',
      ellipsis: true,
      indentStep: 0,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '一、营业总收入',
      dataIndex: 'TotalOperatingRevenue',
      key: 'TotalOperatingRevenue',
      indentStep: 0,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '二、营业总成本',
      dataIndex: 'TotalOperatingCost',
      key: 'TotalOperatingCost',
      indentStep: 0,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '营业成本',
      dataIndex: 'OperatingCost',
      key: 'OperatingCost',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '税金及附加',
      dataIndex: 'OperatingTaxSurcharges',
      key: 'OperatingTaxSurcharges',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '期间费用',
      dataIndex: 'Qijianfeiyong',
      key: 'Qijianfeiyong',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '销售费用',
      dataIndex: 'OperatingExpense',
      key: 'OperatingExpense',
      indentStep: 2,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '管理费用',
      dataIndex: 'AdministrationExpense',
      key: 'AdministrationExpense',
      indentStep: 2,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '研发费用',
      dataIndex: 'RAndD',
      key: 'RAndD',
      indentStep: 2,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '财务费用',
      dataIndex: 'FinancialExpense',
      key: 'FinancialExpense',
      indentStep: 2,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '其他经营收益',
      dataIndex: 'OtherOperatingRevenue',
      key: 'OtherOperatingRevenue',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '其他收益',
      dataIndex: 'OtherRevenue',
      key: 'OtherRevenue',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '投资收益',
      dataIndex: 'InvestIncome',
      key: 'InvestIncome',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '公允价值变动收益',
      dataIndex: 'FairValueChangeIncome',
      key: 'FairValueChangeIncome',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '信用减值损失',
      dataIndex: 'CreditImpairmentL',
      key: 'CreditImpairmentL',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '资产减值损失',
      dataIndex: 'AssetImpairmentLoss',
      key: 'AssetImpairmentLoss',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '资产处置收益',
      dataIndex: 'AssetDealIncome',
      key: 'AssetDealIncome',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '三、营业利润',
      dataIndex: 'OperatingProfit',
      key: 'OperatingProfit',
      indentStep: 0,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '加:营业外收入',
      dataIndex: 'NonoperatingIncome',
      key: 'NonoperatingIncome',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '减:营业外支出',
      dataIndex: 'NonoperatingExpense',
      key: 'NonoperatingExpense',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '四、利润总额',
      dataIndex: 'TotalProfit',
      key: 'TotalProfit',
      indentStep: 0,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '减:所得税费用',
      dataIndex: 'IncomeTaxCost',
      key: 'IncomeTaxCost',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '五、净利润',
      dataIndex: 'NetProfit',
      key: 'NetProfit',
      indentStep: 0,
      slots: { customRender: 'twoNumber' }
    }
  ],
  finance: [
    {
      title: '利润表',
      dataIndex: 'time',
      key: 'time',
      indentStep: 0,
      width: '100px'
    },
    {
      title: '指标',
      dataIndex: 'Title',
      key: 'Title',
      ellipsis: true,
      indentStep: 0,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '一、营业收入',
      dataIndex: 'OperatingRevenue',
      key: 'OperatingRevenue',
      indentStep: 0,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '利息净收入',
      dataIndex: 'NetInterestIncome',
      key: 'NetInterestIncome',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '手续费及佣金净收入',
      dataIndex: 'NetCommissionIncome',
      key: 'NetCommissionIncome',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '投资收益',
      dataIndex: 'InvestIncome',
      key: 'InvestIncome',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '公允价值变动收益',
      dataIndex: 'FairValueChangeIncome',
      key: 'FairValueChangeIncome',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '汇兑收益',
      dataIndex: 'ExchangeIncome',
      key: 'ExchangeIncome',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '其他业务收入',
      dataIndex: 'OtherOperatingRevenue',
      key: 'OtherOperatingRevenue',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '二、营业支出',
      dataIndex: 'OperatingPayout',
      key: 'OperatingPayout',
      indentStep: 0,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '营业税金及附加',
      dataIndex: 'OperatingTaxSurcharges',
      key: 'OperatingTaxSurcharges',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: ' 管理费用',
      dataIndex: 'OperatingAndAdminExpense',
      key: 'OperatingAndAdminExpense',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: ' 资产减值损失',
      dataIndex: 'AssetImpairmentLoss',
      key: 'AssetImpairmentLoss',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '其他业务成本',
      dataIndex: 'OtherOperatingCost',
      key: 'OtherOperatingCost',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '三、营业利润',
      dataIndex: 'OperatingProfit',
      key: 'OperatingProfit',
      indentStep: 0,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: ' 加:营业外收入',
      dataIndex: 'NonoperatingIncome',
      key: 'NonoperatingIncome',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: ' 减:营业外支出',
      dataIndex: 'NonoperatingExpense',
      key: 'NonoperatingExpense',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '四、利润总额',
      dataIndex: 'TotalProfit',
      key: 'TotalProfit',
      indentStep: 0,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '减:所得税',
      dataIndex: 'IncomeTaxCost',
      key: 'IncomeTaxCost',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '五、净利润',
      dataIndex: 'NetProfit',
      key: 'NetProfit',
      indentStep: 0,
      slots: { customRender: 'twoNumber' }
    }
  ],
  insurance: [
    {
      title: '利润表',
      dataIndex: 'time',
      key: 'time',
      indentStep: 0,
      width: '100px'
    },
    {
      title: '指标',
      dataIndex: 'Title',
      key: 'Title',
      ellipsis: true,
      indentStep: 0,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '一、营业收入',
      dataIndex: 'OperatingRevenue',
      key: 'OperatingRevenue',
      indentStep: 0,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '已赚保费',
      dataIndex: 'PremiumsEarned',
      key: 'PremiumsEarned',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '投资收益',
      dataIndex: 'InvestIncome',
      key: 'InvestIncome',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '公允价值变动收益',
      dataIndex: 'FairValueChangeIncome',
      key: 'FairValueChangeIncome',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '汇兑收益',
      dataIndex: 'ExchangeIncome',
      key: 'ExchangeIncome',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '其他业务收入',
      dataIndex: 'OtherOperatingRevenue',
      key: 'OtherOperatingRevenue',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '二、营业支出',
      dataIndex: 'OperatingPayout',
      key: 'OperatingPayout',
      indentStep: 0,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '退保金',
      dataIndex: 'RefundedPremiums',
      key: 'RefundedPremiums',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '赔付支出',
      dataIndex: 'CompensationExpense',
      key: 'CompensationExpense',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '减:摊回赔付支出',
      dataIndex: 'AmortizationExpense',
      key: 'AmortizationExpense',
      indentStep: 2,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '提取保险责任准备金',
      dataIndex: 'PremiumReserve',
      key: 'PremiumReserve',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '减:摊回保险责任准备金',
      dataIndex: 'AmortizationPremiumReserve',
      key: 'AmortizationPremiumReserve',
      indentStep: 2,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '保户红利支出',
      dataIndex: 'PolicyDividendPayout',
      key: 'PolicyDividendPayout',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '分保费用',
      dataIndex: 'ReinsuranceCost',
      key: 'ReinsuranceCost',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '营业税金及附加',
      dataIndex: 'OperatingTaxSurcharges',
      key: 'OperatingTaxSurcharges',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '管理费用',
      dataIndex: 'OperatingAndAdminExpense',
      key: 'OperatingAndAdminExpense',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '减:摊回分保费用',
      dataIndex: 'AmortizationReinsuranceCost',
      key: 'AmortizationReinsuranceCost',
      indentStep: 2,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: ' 资产减值损失',
      dataIndex: 'AssetImpairmentLoss',
      key: 'AssetImpairmentLoss',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '其他业务成本',
      dataIndex: 'OtherOperatingCost',
      key: 'OtherOperatingCost',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '三、营业利润',
      dataIndex: 'OperatingProfit',
      key: 'OperatingProfit',
      indentStep: 0,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: ' 加:营业外收入',
      dataIndex: 'NonoperatingIncome',
      key: 'NonoperatingIncome',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: ' 减:营业外支出',
      dataIndex: 'NonoperatingExpense',
      key: 'NonoperatingExpense',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '四、利润总额',
      dataIndex: 'TotalProfit',
      key: 'TotalProfit',
      indentStep: 0,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '减:所得税',
      dataIndex: 'IncomeTaxCost',
      key: 'IncomeTaxCost',
      indentStep: 1,
      slots: { customRender: 'twoNumber' }
    },
    {
      title: '五、净利润',
      dataIndex: 'NetProfit',
      key: 'NetProfit',
      indentStep: 0,
      slots: { customRender: 'twoNumber' }
    }
  ]
}
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: () => {
        return ''
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  components: { Charts, Table, Nodata, InfoCircleOutlined },
  setup(props, context) {
    const tableData: any = reactive({
      data: [],
      columns: [],
      tags: [],
      activeTagVal: 1,
      spinning: true
    })
    const pageData: any = reactive({
      option: {},
      data1: {},
      data2: {},
      option1: {},
      option2: {}
    })
    getColor(mydata2.data, 0)
    getColor(mydata1.ldzc, 0)
    getColor(mydata1.fldzc, (mydata1.ldzc || []).length)
    watch(
      () => props.pageSourceData || {},
      (val: any) => {
        if (val.EnterpriseType === 35) {
          tableData.columns = myColumns.insurance
        } else if (val.EnterpriseType === 99) {
          tableData.columns = myColumns.ybqy
        } else {
          tableData.columns = myColumns.finance
        }
        pageData.data2 = val.Debt ? getMydata2(val.Debt[0]) : {}
        pageData.data1 = val.Debt ? getMydata1(val.Debt[0]) : {}
        const data = JSON.parse(JSON.stringify(val.Profit))
        if ((data || []).length) {
          data.forEach((item: any, i: number) => {
            item.index = 'Profit1' + i
            item.time = item.EndDate ? window.moment(item.EndDate * 1000).format('YYYY-MM-DD') : '—'
            item.Qijianfeiyong = (item.OperatingExpense || 0) + (item.AdministrationExpense || 0) + (item.FinancialExpense || 0) + (item.RAndD || 0)
            // 各科目占营业总收入的百分比，金融类企业为各科目占营业收入的百分比
            item.FM = [35, 99].indexOf(val.EnterpriseType) === -1 ? item.OperatingRevenue : item.TotalOperatingRevenue
          })
          tableData.data = data.slice(0, 6)
        }
        nextTick(() => {
          tableData.spinning = false
        })
      },
      { deep: true }
    )
    function getMydata2(Debt: any) {
      mydata2.total = Debt.TotalLiability
      ;(mydata2.data[0] || {}).value = Debt.TotalCurrentLiability
      ;(mydata2.data[1] || {}).value = Debt.TotalNonCurrentLiability
      return mydata2
    }

    function getMydata1(Dupont: any) {
      mydata1.ldzcTotal = Dupont.TotalCurrentAssets
      ;(mydata1.ldzc[0] || {}).value = Dupont.CashEquivalents
      ;(mydata1.ldzc[1] || {}).value = Dupont.AccountReceivable
      ;(mydata1.ldzc[2] || {}).value = Dupont.Inventories
      ;(mydata1.ldzc[3] || {}).value = Dupont.AdvancePayment
      mydata1.fldzcTotal = Dupont.TotalNonCurrentAssets
      ;(mydata1.fldzc[0] || {}).value = Dupont.FixedAssets
      ;(mydata1.fldzc[1] || {}).value = Dupont.IntangibleAssets
      ;(mydata1.fldzc[2] || {}).value = Dupont.LongDeferredExpense
      ;(mydata1.fldzc[3] || {}).value = Dupont.GoodWill
      // ;(mydata1.fldzc[4] || {}).value = Dupont.OtherNonCurrentAssets

      mydata1.total = Dupont.TotalCurrentAssets + Dupont.TotalNonCurrentAssets
      // 其他 = 总资产-货币-应收-存货-预付-固定-无形-长期-商誉
      ;(mydata1.fldzc[4] || {}).value =
        mydata1.total -
        (Dupont.CashEquivalents +
          Dupont.AccountReceivable +
          Dupont.Inventories +
          Dupont.AdvancePayment +
          Dupont.FixedAssets +
          Dupont.IntangibleAssets +
          Dupont.LongDeferredExpense +
          Dupont.GoodWill)
      return mydata1
    }
    tableData.tags = [
      {
        label: '按报告期',
        value: 1
      },
      {
        label: '按年度',
        value: 2
      },
      {
        label: '按单季度',
        value: 3
      }
    ]
    async function checkTag(tag: any) {
      tableData.activeTagVal = tag.value
      getDetail(tableData.activeTagVal)
      // tableData.data = await getDetail(pageData.activeTagVal)
      // nextTick(() => {
      //   const blockEl: any = myTableBlock.value;
      //   handleScroll();
      // });
    }
    const route = useRoute()
    function getDetail(type: number) {
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code,
        StaticsType: type,
        DataType: 2
      }
      data.headers = {
        token: props.token
      }
      f10Api.getFinanceF10(data).then((res: any) => {
        const data = JSON.parse(JSON.stringify((res.Data || {}).Profit))
        if ((data || []).length) {
          data.forEach((item: any, i: number) => {
            item.index = 'Debt' + i
            item.time = item.EndDate ? window.moment(item.EndDate * 1000).format('YYYY-MM-DD') : '—'
            item.Qijianfeiyong = (item.OperatingExpense || 0) + (item.AdministrationExpense || 0) + (item.FinancialExpense || 0) + (item.RAndD || 0)
            item.FM = [35, 99].indexOf((props.pageSourceData || {}).EnterpriseType) === -1 ? item.OperatingRevenue : item.TotalOperatingRevenue
          })
          tableData.data = data.slice(0, 6)
        } else {
          tableData.data = []
        }
      })
    }
    function getNumber2(val: any) {
      return globalsets.getNumber2(val)
    }

    function getColor(data: any, i: number) {
      if (!(data || []).length) return []
      data.forEach((element: any, idx: number) => {
        element.color = color[idx + i]
      })
    }
    watch(
      () => pageData.data1,
      (val: any) => {
        nextTick(() => {
          const d: any = getData(val)
          pageData.option1 = setOptions(d)
        })
      }
    )
    function setOptions(val: any) {
      return {
        color: color,
        legend: {
          show: false
        },
        tooltip: {
          trigger: 'item',
          formatter: (params: any) => {
            return `<div class="toolTip"><div>${params.name}</div><div><i style="background:${params.color}"></i>比例 ${params.value}%</div></div>`
          },
          position: 'right'
        },
        series: [
          {
            type: 'pie',
            label: {
              show: false
            },
            data: val,
            itemStyle: {
              normal: {
                color: function(params: any) {
                  return color[params.dataIndex]
                }
              }
            }
          }
        ]
      }
    }

    function getData(data: any) {
      if (Object.keys(data).length > 0) {
        return [
          { value: computedPrecent1(data.ldzc[0].value, data.total), name: '货币资金' },
          { value: computedPrecent1(data.ldzc[1].value, data.total), name: '应收账款' },
          { value: computedPrecent1(data.ldzc[2].value, data.total), name: '存货' },
          { value: computedPrecent1(data.ldzc[3].value, data.total), name: '预付账款' },
          { value: computedPrecent1(data.fldzc[0].value, data.total), name: '固定资产' },
          { value: computedPrecent1(data.fldzc[1].value, data.total), name: '无形资产' },
          { value: computedPrecent1(data.fldzc[2].value, data.total), name: '长期待摊费用' },
          { value: computedPrecent1(data.fldzc[3].value, data.total), name: '商誉' },
          { value: computedPrecent1(data.fldzc[4].value, data.total), name: '其他' }
        ]
      } else {
        return []
      }
    }
    function getData2(data: any) {
      if (Object.keys(data).length > 0) {
        return [
          { value: computedPrecent1(data.data[0].value, data.total), name: '流动负债' },
          { value: computedPrecent1(data.data[1].value, data.total), name: '非流动负债' }
        ]
      } else {
        return []
      }
    }
    watch(
      () => pageData.data2,
      (val: any) => {
        const d: any = getData2(val)
        nextTick(() => {
          pageData.option2 = setOptions(d)
        })
      }
    )
    // onMounted(() => {
    //   const elem: HTMLElement = document.getElementById('NumberofShareholders1') as HTMLElement
    //   let myChart = echarts.init(elem)
    //   myChart.setOption(pageData.option1)
    //   const elem2: HTMLElement = document.getElementById('NumberofShareholders2') as HTMLElement
    //   let myChart2 = echarts.init(elem2)
    //   myChart2.setOption(pageData.option2)
    // })
    function computedPrecent(item: number, total: number) {
      if (!Number(total) || !Number(item)) return '—'
      return ((item / total) * 100).toFixed(2) + '%'
    }
    function computedPrecent1(item: number, total: number) {
      if (!Number(total) || !Number(item)) return '0'
      return ((item / total) * 100).toFixed(2)
    }
    function formatNum(num: any) {
      const n = Math.abs(num)
      const res = n >= 100000000 ? (n / 100000000).toFixed(2) + '亿' : n >= 10000 ? (n / 10000).toFixed(2) + '万' : n && String(n) !== '0' ? n.toFixed(2) : '—'
      return num < 0 ? '-' + res : res
    }
    return {
      ...toRefs(pageData),
      ...toRefs(tableData),
      computedPrecent,
      checkTag,
      getNumber2,
      formatNum
    }
  }
})
